export default __webpack_public_path__ + "static/media/Icons_Water_Fill_Blue Icon.b1ed3c9e.svg";